import React from 'react';

function DigitalMarketingAgencySection() {
  const scrollToForm = () => {
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSeeOurWork = (e) => {
    e.preventDefault();
    const portfolioEl = document.getElementById('digital-marketing-portfolio') || document.querySelector('.ecom-portfolio-section');
    if (portfolioEl) {
      portfolioEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="dig-agency-section">
      <div className="container dig-agency-container">
        {/* Left Column: Image */}
        <div className="dig-agency-left">
          <div className="dig-agency-img-wrapper">
            <img
              src="/assets/images/digital-marketing/dig-img1.jpg"
              alt="Best Digital Marketing Agency In Karachi"
              className="dig-agency-img"
            />
          </div>
        </div>

        {/* Right Column: Content */}
        <div className="dig-agency-right">
          <div className="dig-agency-header">
            <div className="dig-agency-red-bar"></div>
            <h2 className="dig-agency-title">
              Best <span className="text-red">Digital Marketing Agency</span><br />
              In Karachi
            </h2>
          </div>

          <p className="dig-agency-desc">
            Present-day digital marketing is not like traditional advertising. The best digital marketing agency services require a complete, data-driven approach that connects your brand with customers. Our digital marketing agency in Karachi creates professional campaigns that combine <a href="/seo-services/" className="dig-agency-highlight-link">search engine optimization</a>, <a href="/social-media-marketing/" className="dig-agency-highlight-link">social media marketing</a>, and content strategy to maximize your online presence for your business growth. Our team improves your identity and allows your business to grab high-intent prospects. You can also create customer relationships and change your digital channels into revenue-generating platforms with our online marketing company.
          </p>

          <p className="dig-agency-desc">
            Get professional digital marketing solutions to multiply your returns with online campaigns.
          </p>

          <div className="dig-agency-actions">
            <button className="btn-dig-primary" onClick={scrollToForm}>
              Let's Discuss Your Needs
            </button>
            <a
              href="#digital-marketing-portfolio"
              className="btn-dig-secondary"
              onClick={handleSeeOurWork}
            >
              See our work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingAgencySection;
